import { useLocation, useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { ESelfServeTaskStatus } from 'common/contracts';
import { EEventsType } from 'constants/enums';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';
import { trackMixpanelEvent } from 'utils/mixpanelClient';

import { cn } from 'components/lib/utils';

import { ISetupChecklistTask } from '../types';

interface ISetupChecklistTaskProps {
  task: ISetupChecklistTask;
}

const mapStatusToIcon: Partial<Record<ESelfServeTaskStatus, React.ReactNode>> =
  {
    done: (
      <FontAwesomeIcon
        icon={`fa-solid fa-circle-check`}
        className="text-xs text-indigo-500"
      />
    ),
    open: <FontAwesomeIcon icon={`fa-regular fa-circle`} className="text-xs" />,
    pending: (
      <FontAwesomeIcon
        icon={`fa-regular fa-circle-dashed`}
        className="text-xs"
      />
    )
  };

export const SetupChecklistTask: React.FC<ISetupChecklistTaskProps> = ({
  task
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setTaskStatus, toggleChecklistExpandedState, isExpanded } = useChecklistState();

  const { status, title, action } = task;

  const isLocked = status === ESelfServeTaskStatus.LOCKED;

  const markDone = () => {
    setTaskStatus(task.id);
  };

  const publisherId = location.pathname.split('/project/')[1]?.split('/')[0];

  return (
    <div
      className={cn(
        'w-full text-base-mutedForeground text-xs mt-3',
        action && 'cursor-pointer'
      )}
      onClick={() => {
        action?.({
          navigate,
          markTaskAsDone: markDone,
          publisherId,
          toggleChecklist: toggleChecklistExpandedState
        });
      
        if (isExpanded && action) {
          trackMixpanelEvent(EEventsType.DASHBOARD_SETUP_GUIDE_TASK_CLICKED, {
            task_name: title,
            task_status: status
          });
        }
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {!isLocked && mapStatusToIcon[status as ESelfServeTaskStatus]}
          <div>{title}</div>
        </div>
        {status === ESelfServeTaskStatus.LOCKED && (
          <FontAwesomeIcon
            icon={`fa-solid fa-lock text-base-mutedForeground`}
            className="text-xs self-end"
          />
        )}
      </div>
    </div>
  );
};
